<!--物品表新上传组件-->
<template>
  <div class="projectUpload" style="min-width: 500px; padding-bottom: 5px;">
    <div style="padding-bottom: 5px;">
      <div v-if="fileList.length>0" style="margin-bottom: 5px;">
        <div style="width: 100%; min-height: 425px; border: 1px solid #DCDFE6;">
          <img
            @click="showPic()"
            :src="getImgPath(currentFile)"
            style="width: 100%; height: 100%; object-fit: contain; cursor: pointer; padding: 1px;"
          />
        </div>
        <!-- <div style="padding: 5px; font-size: 24px;">
          <el-tooltip v-if="currentFile.description.length > fontSize" placement="top">
            <div slot="content">{{currentFile.description}}</div>
            <span>{{currentFile.description.substr(0, fontSize)}}...</span>
          </el-tooltip>
          <span v-else style="word-break: break-all;">{{currentFile.description}}</span>
        </div> -->
        <div style="clear: both;"></div>
      </div>
      <el-row>
        <div
          style="float: left; width: 80px;position: relative;"
          v-for="(item,index) in fileList"
          :key="item.id"
        >
          <el-image
            :src="getImgPath(item)"
            @click="navToImg(item, index)"
            @error="hideErrorImage(item)"
            :class="isFocusImg(item)?'imgBorder imgClass':'imgClass'"
          ></el-image>

          <span
            v-show="!readOnly"
            :style="'border-color:'+defaultTheme+' !important; cursor: pointer; '"
            class="image-remove-icon"
            @click="del(item.id)"
          >
            <i
              class="el-icon-close"
              :style="item.imgEmpty||item.filesIn==''?'display:block !important;color:'+defaultTheme+' !important;top:0px;right:0px;':'display:block !important;top:0px;right:0px;'"
            ></i>
          </span>

          <span
            v-show="!readOnly"
            :style="'border-color:'+defaultTheme+' !important; cursor: pointer; '"
            class="image-edit-icon"
            @click="edit(item.id)"
          >
            <i
              class="el-icon-edit-outline"
              :style="item.imgEmpty||item.filesIn==''?'display:block !important;color:'+defaultTheme+' !important;top:0px;right:0px;':'display:block !important;top:0px;right:0px;'"
            ></i>
          </span>
        </div>
        <div class="buttonDiv" v-if="readOnly">
          <div class="buttonClass" :disabled="false" @click="refreshList">
            <i class="el-icon-refresh" style="font-size: 28px; color: #8c939d;"></i>
          </div>
        </div>
        <div class="buttonDiv" v-if="!readOnly">
          <div class="buttonClass" :disabled="false" @click="add">{{ readOnly }}
            <i class="el-icon-plus" style="font-size: 28px; color: #8c939d;"></i>
          </div>
        </div>
      </el-row>
    </div>

    <!-- 弹窗, 新增 / 修改 -->
    <itemActivityForm
      ref="itemActivityForm"
      :fileStorePath="fileStorePath"
      @refreshDataList="refreshList"
      @canceladd="delWithoutConfirm"
    ></itemActivityForm>

    <div v-show="false"  class="images">
      <img v-for="(item, index) in allImg" :src="item.src" :key="index" :alt="item.alt" />
    </div>
  </div>
</template>

<script>
import itemActivityForm from '@/components/file/itemActivityForm'
export default {
  props: {
    itemId: {
      type: String,
      default: ''
    },
    projectName: {
      type: String,
      default: ''
    },
    itemCode: {
      type: String,
      default: ''
    },
    qualityId: {
      type: String,
      default: ''
    },
    qualityName: {
      type: String,
      default: ''
    },
    owner: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    eventCode: {
      type: String,
      default: ''
    },
    eventCodeNew: {
      type: String,
      default: ''
    },
    picHeight: {
      // 主图高度
      type: String,
      default: '252'
    },
    fontSize: {
      // 描述文字数量，超过则隐藏
      type: Number,
      default: 999
    }
  },
  data () {
    return {
      fileStorePath: '',
      parentPath: 'item',
      fileList: [],
      allImg: [],
      currentFile: {}, // 主图，当前图片
      currentIndex: 0,
      defaultTheme: localStorage.defaultTheme
    }
  },
  components: {
    itemActivityForm
  },
  watch: {
    owner (val, oldVal) {
      if (val !== oldVal && val !== '') {
        this.init()
        this.refreshList()
      }
    }
  },
  created () {},
  computed: {},
  activated () {},
  mounted () {
    if (this.itemId !== '') {
      this.init()
      this.refreshList()
    }
  },
  methods: {
    showPic () {
      const vuer = this.$el.querySelector('.images').$viewer
      // vuer.show()
      vuer.view(this.currentIndex)
    },
    hideErrorImage (item) {
      this.$set(item, 'imgEmpty', true)
    },
    getAllImg () {
      // 所有图片
      this.allImg = []
      for (let file of this.fileList) {
        let params = {
          src: this.getImgPath(file),
          alt: file.description
        }
        this.allImg.push(params)
      }
    },
    getMathRandom () {
      return '?' + new Date().getTime() + '' + Math.floor(Math.random() * 10)
    },
    getImgPath (item) {
      // 获取图片链接
      if (item === undefined) {
        return ''
      }
      return item.filePath
    },
    navToImg (file, index) {
      // 点击小图片
      this.currentFile = file
      this.currentIndex = index
    },
    isFocusImg (file) {
      // 聚焦小图片
      // console.log(file)
      // console.log(this.getImgPath(file), this.getImgPath(this.currentFile))
      return this.getImgPath(file) === this.getImgPath(this.currentFile)
    },
    init () {
      this.currentFile = {}
      this.fileList = []
    },
    // 获取数据列表
    refreshList () {
      this.loading = true
      // this.fileList = []
      let params = {
        current: 1,
        size: 100,
        ownerId: this.itemId,
        category: 'portfolio_gallery'
      }

      if (!this.eventCodeNew === false && this.eventCodeNew === 'ItemInquiry') {
        if (!this.itemCode === false) {
        } else {
          return false
        }
      }
      this.$http({
        url: '/unmfile/cecUnmFile/list',
        method: 'get',
        params: params
      }).then(({ data }) => {
        this.loading = false
        if (data && data.records) {
          // this.fileList = []
          this.fileList = JSON.parse(JSON.stringify(data.records))
          let idsArr = []
          this.fileList.forEach(item => {
            item.filesIn = item.filesIn + this.getMathRandom()
            idsArr.push(item.id)
          })
          this.getAllImg()
          if (this.fileList.length > 0) {
            this.currentFile = this.fileList[0]
            this.currentIndex = 0
          }
          if (!idsArr === false && idsArr.length > 0) {
            this.$emit('refreshDataList', idsArr.join(','))
          }
        }
      })
    },
    //  新增
    /**
     * 工程项目例子
     * ownerId: 8d06c2d172e24c03ab7ca5df5e16f689
     * eventCategory: 工程项目
     * eventCode: Project
     * eventName: 工程项目
     * ownerCode: GCAZ-001
     * ownerName: 衣柜层板
     * tags:''
     * fileStorePath:GCXM/GCAZ-001/
     *
     * 工程项目质量标准例子
     * ownerId: 8d06c2d172e24c03ab7ca5df5e16f689
     * eventCategory: 工程项目_质量标准
     * eventCode: Project_Quality
     * eventName: 工程项目
     * ownerCode: GCAZ-001
     * ownerName: 衣柜层板（商业翻新-公寓-starlight）
     * tags: qualityId
     * fileStorePath:GCXM/GCAZ-001/qualityId/
     * */
    add () {
      let ownerId = this.itemId
      let eventCategory = '物品图片'
      let eventName = '物品图片'
      let ownerCode = this.itemCode
      let ownerName = '物品图片'
      let tags = this.qualityId
      this.fileStorePath = this.parentPath + '/' + ownerCode + '/'
      this.$refs.itemActivityForm.createNewRecordForOwnerId(
        ownerId,
        eventCategory,
        this.eventCode,
        eventName,
        ownerCode,
        ownerName,
        tags,
        this.fileStorePath,
        this.qualityName,
        this.allImg.length + Number(1)
      )
    },
    // 删除,不提示
    delWithoutConfirm (id) {
      // let ids = id || this.dataListSelections.map(item => {
      // return item.id
      // }).join(',')
      this.loading = true
      this.$http({
        url: '/cec/property/management/activity/activity/delete',
        method: 'delete',
        params: { ids: id }
      }).then(({ data }) => {
        if (data && data.success) {
          this.refreshList()
        }
        this.loading = false
      })
    },
    // 修改
    edit (id) {
      this.$refs.itemActivityForm.init('edit', id)
    },
    del (id) {
      this.$confirm(`确定删除所选项吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$http({
          url: '/cec/property/management/activity/activity/delete',
          method: 'delete',
          params: { ids: id }
        }).then(({ data }) => {
          if (data && data.success) {
            this.$message.success(data.msg)
            this.refreshList()
          }
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped>
.projectUpload .imgClass {
  float: left;
  width: 100%;
  height: 75px;
  padding: 3px;
  cursor: pointer;

  /* width: 130px;
  padding-bottom: 56.25%;
  position: relative; */
}
/* .projectUpload .el-image__inner {
  width: 100%;
  height: 100%;
  position: absolute;
} */
.projectUpload .delIconClass {
  font-size: 24px;
  color: white;
  float: right;
  position: relative;
  right: 0px;
  top: -75px;
  opacity: 1;
  cursor: pointer;
}
.projectUpload .editIconClass {
  font-size: 24px;
  color: white;
  float: right;
  position: relative;
  right: -23px;
  top: -25px;
  opacity: 1;
  cursor: pointer;
}
.projectUpload i.el-icon-circle-close:hover {
  opacity: 1;
}
.projectUpload .imgBorder {
  border: solid 2px #2ea5f8;
}
.projectUpload .buttonDiv {
  float: left;
  margin: 3px;
}
.projectUpload .buttonClass {
  width: 69px;
  height: 69px;
  background: #f8f8f8;
  border: 1px solid #d2d2d2;
  text-align: center;
  line-height: 80px;
}
.image-remove-icon {
  font-size: 20px;
  font-weight: bold;
  width: 22px !important;
  height: 22px !important;
  text-align: center !important;
  top: 0px !important;
  right: 0px !important;
  display: block;
  position: absolute !important;
  z-index: 999;
  opacity: 0.8;
  background-color: #fff;
  border: 1px solid #d9d9d9;
}

.image-edit-icon {
  font-size: 20px;
  font-weight: bold;
  width: 22px !important;
  height: 22px !important;
  text-align: center !important;
  bottom: 0px !important;
  right: 0px !important;
  display: block;
  position: absolute !important;
  z-index: 999;
  opacity: 0.8;
  background-color: #fff;
  border: 1px solid #d9d9d9;
}
</style>
